// Progress bar (RESTYLE §2, §3): the run clock to its timeout (live), hashing progress (neutral).
//   <ProgressBar value label max? tone? size? valueText? className? />
//       value / max (max defaults to 1), clamped; tone "live" (cyan) | "neutral" (ink-soft); size sm 3px | md 4px | lg 6px
//       role=progressbar with aria-valuenow in percent; valueText reads e.g. "0:42 of a 5:00 timeout"
import { cx, vars } from "./cx";

export function ProgressBar({
  value,
  label,
  max = 1,
  tone = "neutral",
  size = "md",
  valueText,
  className,
}: {
  value: number;
  label: string;
  max?: number;
  tone?: "live" | "neutral";
  size?: "sm" | "md" | "lg";
  valueText?: string;
  className?: string;
}) {
  const p = max > 0 && Number.isFinite(value) ? Math.max(0, Math.min(1, value / max)) : 0;
  return (
    <div
      className={cx("pbar", tone === "live" && "pbar--live", size !== "md" && `pbar--${size}`, className)}
      style={vars({ "--p": p })}
      role="progressbar"
      aria-label={label}
      aria-valuemin={0}
      aria-valuemax={100}
      aria-valuenow={Math.round(p * 100)}
      aria-valuetext={valueText}
    >
      <i />
    </div>
  );
}
